import React from "react";
import { Table } from "semantic-ui-react";

export const huntingFishingContent = (
  <Table className={"coverage-area-table"}>
    <Table.Body>
      <Table.Row>
        <Table.HeaderCell colSpan={3}>Hunting/Fishing License</Table.HeaderCell>
      </Table.Row>
      <Table.Row>
        <Table.Cell>
          <Table className={"coverage-area-inner-table"}>
            <Table.Body>
              <Table.Row>
                <Table.Cell>Arkansas*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Alaska</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Arkansas</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Connecticut</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Florida</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Georgia</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Illinois*</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Table.Cell>
        <Table.Cell>
          <Table className={"coverage-area-inner-table"}>
            <Table.Body>
              <Table.Row>
                <Table.Cell>Massachusetts</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Minnesota</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Mississippi</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Missouri</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Montana</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Nevada</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>New Jersey*</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Table.Cell>
        <Table.Cell>
          <Table className={"coverage-area-inner-table"}>
            <Table.Body>
              <Table.Row>
                <Table.Cell>North Carolina*</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>North Dakota</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Ohio</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Oregon</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Utah</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Virginia</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Wisconsin</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Table.Cell>
      </Table.Row>
      <Table.Row>
        <Table.Row>
          <Table.Cell colSpan={3} className={"red-text"}>
            * Only historical data available
          </Table.Cell>
        </Table.Row>
      </Table.Row>
    </Table.Body>
  </Table>
);

export default huntingFishingContent;



// WEBPACK FOOTER //
// ./src/components/coveragearea/HuntingFishing.js